import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout";
import { PageWithSettingsComponent } from 'shared/components/page-with-settings';
import { useParams } from "react-router-dom";
import { EtfPageParams as EtfPageRouteParams, EtfPageSection } from "../model";
import { EtfPageSettingsTitle } from '../shared/settings-title';
import { EtfPageSettingsContent } from "../shared/settings-content";
import { useEffect, useState } from "react";
import { EtfService, IEtfBackend } from "api/etf";
import { LoadingComponent } from "shared/components/loading";
import { prerenderMarkLoaded } from "shared/mechanics/prerender";
import { scrollByFragment } from "shared/mechanics/scrollByFragment";
import { usePageMeta } from "shared/mechanics/page-meta";
import { EtfFactorAnalysisPageContent } from './components/content';
import { AnalysisService, FactorAnalsysisBackend } from "api/analysis";
import { TextMockScreen } from 'shared/ui-kit';
import moment from "moment";

type FactorAnalysisLoadState = { isLoaded: false } | { isLoaded: true, data: FactorAnalsysisBackend | null };

export const EtfFactorAnalysisPage = () => {
	const params = useParams<EtfPageRouteParams>();
	const [etfInfo, setEtfInfo] = useState<IEtfBackend | null>(null);
	const [factorAnalysisRub, setFactorAnalysisRub] = useState<FactorAnalysisLoadState>({ isLoaded: false });
	const [factorAnalysisUsd, setFactorAnalysisUsd] = useState<FactorAnalysisLoadState>({ isLoaded: false });

	useEffect(
		() => { EtfService.info(params.ticker).then(etf => setEtfInfo(etf)); },
		[]);
	useEffect(
		() => {
			AnalysisService.fetchFactor(params.ticker, 'RUB')
				.then(result => setFactorAnalysisRub({ isLoaded: true, data: result }))
				.catch(() => setFactorAnalysisRub({ isLoaded: true, data: null }));
		},
		[]);
	useEffect(
		() => {
			AnalysisService.fetchFactor(params.ticker, 'USD')
				.then(result => setFactorAnalysisUsd({ isLoaded: true, data: result }))
				.catch(() => setFactorAnalysisUsd({ isLoaded: true, data: null }));
		},
		[]);

	usePageMeta({
		title: etfInfo == null
			? 'Загрузка данных'
			: `${etfInfo.ticker} - риски фонда`,
		description: etfInfo == null
			? ''
			: `Зависимость ${etfInfo.ticker} от цен золота, курса доллара и евро, уровней S&P и IMOEX`,
		keyWords: etfInfo == null
			? []
			: ['риски', 'драйверы', 'факторы', 'причины', 'следствия'],
		canonicalPath: `etf/${params.ticker}/analysis/factor`
	});

	if (etfInfo == null || !factorAnalysisRub.isLoaded || !factorAnalysisUsd.isLoaded)
		return (
			<SiteLayoutComponent activeSection={SiteSection.None}>
				<LoadingComponent />
			</SiteLayoutComponent>
		);

	prerenderMarkLoaded();
	scrollByFragment();

	const numOfTradingMonths = moment(Date.now()).diff(moment(etfInfo.tradingStartDate), 'months', true);

	const content = factorAnalysisRub.data === null && factorAnalysisUsd.data === null
		? <TextMockScreen text={numOfTradingMonths < 1 ? "Данные отсутствуют, так как фонд начал торговаться недавно" : "Данные отсутствуют, так как статистика по факторам не собрана"} />
		: <EtfFactorAnalysisPageContent etf={etfInfo} factorAnalysisRub={factorAnalysisRub.data} factorAnalysisUsd={factorAnalysisUsd.data} />;

	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<PageWithSettingsComponent
				defaultIsSettingsExpanded={true}
				settingsTitleChild={props => <EtfPageSettingsTitle {...props} ticker={etfInfo.ticker} shortDescription={etfInfo.shortDescription} />}
				settingsContentChild={<EtfPageSettingsContent section={EtfPageSection.ANALYSIS_FACTOR} etf={etfInfo} />}
				settingCompactModeShowButtonText={etfInfo.ticker}
				contentChild={content} />
		</SiteLayoutComponent>
	)
};